const heroSlider = document.querySelectorAll('[data-slider="hero-slider"]');

const heroSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 800,
  watchOverflow: true,
  loop: true,
  autoHeight: true,
  autoplay: {
    delay: 5000,
  },
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    1023: {
      slidesPerView: 1,
      spaceBetween: 0,
      autoHeight: false,
    },
  },
};

heroSlider.forEach((el) => {
  const parentEle = el.closest('.hero-module');
  const arrowRight = parentEle.querySelector('.swiper-button-next');
  const arrowLeft = parentEle.querySelector('.swiper-button-prev');
  const paginationElement = parentEle.querySelector('.swiper-pagination');

  heroSliderOptions.navigation.nextEl = arrowRight;
  heroSliderOptions.navigation.prevEl = arrowLeft;
  heroSliderOptions.pagination.el = paginationElement;

  new Swiper(el, heroSliderOptions);
});
